import { createFileRoute } from "@tanstack/react-router";
import { TotesKapitalSeite } from "@/components/TotesKapitalSeite";

/*
 * `/totes-kapital`. Dünn wie `controlling.tsx`: die Seite liegt in
 * `src/components/` und ist dadurch ohne Router testbar.
 *
 * Kein `loader`, kein `beforeLoad` — die Daten holt der Query-Hook der
 * Komponente, damit Lade-, Fehler- und Zugangszustand derselben Stelle
 * gehören, die sie anzeigt.
 */
export const Route = createFileRoute("/totes-kapital")({
  component: TotesKapitalSeite,
});
